import { Icon, Tooltip } from "@mui/material";

const agentMenus = [
  {
    icon: (
      <Tooltip title="Agent Dashboard">
        <Icon fontSize="medium">view_carousel</Icon>
      </Tooltip>
    ),
    key: "agentDashboard",
    name: "Agent Dashboard",
    url: "home/app/agent dashboard",
    description: "Agent Dashboard",
    disabled: false,
    productionReady: true,
  },
];

export { agentMenus };
